// extracted by mini-css-extract-plugin
export default {"tableContainerModal":"TableWithoutButtons_tableContainerModal__Bi42d"};